import React, { useState } from 'react'
import { FaBars, FaTimes } from 'react-icons/fa'
import {Link} from "react-scroll"

const NavBar = () => {


    const [nav, setNav] = useState(false)

    const links = [
        {
            id: 1,
            link: "home",
            label: "home"
        },
        {
            id: 2,
            link: "about",
            label: "about"
        },
        {
            id: 3,
            link: "projects",
            label: "projects"
        },
        {
            id: 4,
            link: "footer",
            label: "contact"
        },

    ];


  return (
    <div className='flex justify-between items-center w-full h-20 px-4 text-white fixed top-0 z-50 bg-black'>
        <div>
            <h1 className='text-4xl sm:text-5xl font-signature ml-2'>Väinö</h1>
        </div>

        <ul className='hidden md:flex'>

            {links.map(({ id, link, label }) => (
                <li key={id}
                className='px-4 cursor-pointer capitalize font-medium text-gray-300 hover:scale-105 duration-200'
                >
                    <Link to={link} smooth={500} offset={-80}>{label}</Link>
                    </li>
            ))}
        </ul>

        <div onClick={() => setNav(!nav)} className='cursor-pointer pr-2 z-10 text-gray-300 md:hidden'>
            {nav ? <FaTimes size={30} /> : <FaBars size={30} />}

        </div>

        {nav && (
            <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-300 md:hidden'>

            {links.map(({ id, link, label }) => (
                    <li key={id}
                    className='px-4 cursor-pointer capitalize py-6 text-4xl'
                    >
                        <Link onClick={() => setNav(false)} to={link} smooth={500} offset={-80}>{label}</Link>
                        </li>
                ))}

            </ul>

        )}

    </div>
  )
}

export default NavBar
